<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfBusinesses="true"
              :filterOfLots="false"
              :isRequiredFarms="true"
              :isRequiredBusinesses="true"
              classBusinesses="`col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6`"
              classFarms="`col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6`"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="tableData.length > 0">
        <card class="custom-shadow-card-header custom-table-responsive">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            ></card-header>
            <master-table :infoTable="queriedData" :columns="tableColumns">
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <export-tables
            :pdf="{
              filename: `${$t('sowing.summary_report')}_${dateToday}.pdf`,
              route: 'reports/reportsummary/pdf',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
            :xls="{
              filename: `${$t('sowing.summary_report')}_${dateToday}.xlsx`,
              route: 'reports/reportsummary/excel',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
          />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getDateToday } from 'src/util/Util';
import configTable from 'src/views/Pages/Dashboard/SowingReports/SummaryReport/summaryReportTable';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
  },
  computed: {
    ...configTable().Search,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    dateToday() {
      return getDateToday();
    },
    exportData() {
      const response = { data: { ...this.tableData } };
      delete response.route;

      return response;
    },
  },
  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  watch: {
    '$i18n.locale': 'setupTable',
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.getData();
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.route = 'reports/reportsummary';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
          if (this.tableData.length > 0) {
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
  created() {
    this.setupTable();
  },
  mounted() {
    this.selectedItemOnMenu('reports');
  },
  destroyed() {
    this.deselectedItemOnMenu('reports');
  },
};
</script>
